const initState = {
    fetching: false,
    fetched: false,
    error: null,
    payload: {},
    summary: null,
    saved: false,
    message: null,
    isDeleted: false,
};

const orderADMSystemReportReducer = (state = initState, action) => {
    switch (action.type) {
        case 'ORDERADMSYSTEMREPORT_PENDING':
            return {
                ...state,
                fetching: true
            };
        case 'ORDERADMSYSTEMREPORT_REJECTED':

            if (action.payload.response.status === 401) {
                localStorage.removeItem('token');
            }

            return {
                ...state,
                error: action.payload.response,
                fetching: false
            };
        case 'ORDERADMSYSTEMREPORT_FULFILLED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                payload: action.payload.data,
                error: null,
                saved: false,
                isDeleted: false
            };
        case 'GET_SUMMARY_PENDING':
            return {
                ...state,
                fetching: true
            };
        case 'GET_SUMMARY_REJECTED':

            if (action.payload.response.status === 401) {
                localStorage.removeItem('token');
            }

            return {
                ...state,
                error: action.payload.response,
                fetching: false
            };
        case 'GET_SUMMARY_FULFILLED':
            return {
                ...state,
                fetching: false,
                fetched: true,
                summary: action.payload.data.summary,
                error: null,
                saved: false,
            };
        default:
            return state;
    }
};

export default orderADMSystemReportReducer;
